import React, { Fragment, HTMLProps } from 'react';
import { Transition, TransitionChild } from '@headlessui/react';

const ModalScreenBase: React.FC<{ isShown: boolean } & HTMLProps<HTMLDivElement>> = ({
    isShown,
    className,
    children,
}) => {
    return (
        <Transition show={isShown} as={Fragment}>
            <div className={`fixed inset-0 text-base z-100 ${className}`}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className={`fixed inset-0 bg-black/80 transition-opacity`} />
                </TransitionChild>
                <TransitionChild
                    as="div"
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    className="relative w-full transform p-0 md:p-10 z-100"
                >
                    {children as React.ReactNode}
                </TransitionChild>
            </div>
        </Transition>
    );
};

export const ModalScreenFunds: React.FC<{ isShown: boolean } & HTMLProps<HTMLDivElement>> = ({
    isShown,
    className,
    children,
}) => {
    return (
        <ModalScreenBase
            isShown={isShown}
            className={`${className} overflow-y-auto overscroll-contain`}
            children={children}
        />
    );
};

export const ModalScreenInvestment: React.FC<{ isShown: boolean } & HTMLProps<HTMLDivElement>> = ({
    isShown,
    className,
    children,
}) => {
    return (
        <ModalScreenBase
            isShown={isShown}
            className={`${className} overflow-y-auto overscroll-contain`}
            children={children}
        />
    );
};

export const ModalScreenPension: React.FC<
    { isShown: boolean; useStdModalStyle?: boolean } & HTMLProps<HTMLDivElement>
> = ({ isShown, useStdModalStyle = true, className, children }) => {
    return (
        <ModalScreenBase
            isShown={isShown}
            className={`${className} ${
                useStdModalStyle && 'w-full lg:w-5/6 xl:w-2/3 md:mx-auto'
            } overflow-y-auto overscroll-contain`}
            children={children}
        />
    );
};
